import getComponent from './component';

const getVisibilityState = (state) => {
  const componentId = getComponent(state).id;
  return Boolean(componentId);
};

export default getVisibilityState;
